import React from 'react';

import Button from '@material-ui/core/Button';
import PlayCircleOutlineIcon from '@material-ui/icons/PlayCircleOutline';
import VideoLibraryOutlinedIcon from '@material-ui/icons/VideoLibraryOutlined';

export default (props) => {
  const url = props.config.videoUrl;
  const videoId = props.config.videoId;
  const title = props.config.videoTitle;
  const isLive = (props.config.isLive === true);
  const isVoD= (props.config.isVoD === true);
  const isPending = (props.config.isPending === true);
  return (
    <>
    { isLive &&
      <Button size="small" variant="contained" color="secondary" startIcon={<PlayCircleOutlineIcon />} onClick={e => props.setVideoSrc(url, videoId, title)}>watch live</Button>
    }
    { isVoD &&
      <Button size="small" variant="contained" color="default" startIcon={<PlayCircleOutlineIcon />} onClick={e => props.setVideoSrc(url, videoId, title)}>watch replay</Button>
    }
    { isPending &&
      <Button size="small" variant="contained" color="default" startIcon={<VideoLibraryOutlinedIcon />} onClick={e => props.setVideoSrc(url, videoId, title)} disabled>video pending ...</Button>
    }
    </>
  );
}
